import { render } from "./ActivityDetail.vue?vue&type=template&id=2c405155&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"

import "./ActivityDetail.vue?vue&type=style&index=0&id=2c405155&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c405155"]])

export default __exports__